<ng-container *transloco="let t; prefix: scope">
  @let prof = profile();

  <button type="button" class="flex grow items-center gap-2 text-left" (click)="onPrimaryActionClick(primaryAction())">
    <rma-avatar class="!h-8 !w-8" [avatar]="prof.profileImage" [name]="prof.name" />

    <div class="flex grow flex-col">
      <span [innerHtml]="prof.name | typeAheadHighlight: searchTerm()"></span>
      <span class="text-sm text-steel-60">
        {{ parentNames() }}
      </span>
    </div>

    @if (isActive()) {
      <div class="shrink-0 rounded-2xl bg-caution-50 px-3 py-1.5 text-xs">{{ t('loggedInAs') }}</div>
    }

    @switch (primaryAction()) {
      @case ('stop') {
        <button type="button" class="-mr-1.5 !text-sm" mat-button color="primary">
          {{ t('stopAssisting') }}
        </button>
      }
      @case ('switch') {
        <rma-icon [matTooltip]="t('tooltips.switchProfile')" glyph="login" theme="primary" />
      }
      @case ('manage') {
        <rma-icon [matTooltip]="t('tooltips.manageAccess')" glyph="group" theme="primary" />
      }
    }
  </button>

  @if (!isIndividual()) {
    <button
      type="button"
      class="flex shrink items-center gap-2 pl-2 text-left"
      [matTooltip]="t('tooltips.manageProfiles')"
      (click)="onManageAccess(profile())"
    >
      <rma-icon glyph="group" theme="primary" />
    </button>
  }
</ng-container>
